import { createTheme } from '@material-ui/core/styles';

const stepperActiveColor = "rgb(29, 90, 109)";
const primaryColor = "#E84129";
// A custom theme for this app
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 1024,
            lg: 1440,
            xl: 1920,
        },
    },
    palette: {
        type: 'light',
        background: {
            default: '#EFEFF0',
            paper: '#ffffff',
        },
        primary: {
            main: primaryColor,
            light: '#cc4056',
            dark: '#8c0017',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#535470',
            light: '#74748f',
            dark: '#383a53',
        },
        error: {
            main: '#cc4056',
            light: '#ffedf0',
            dark: '#8c0017',
        },
        warning: {
            main: '#fabb55',
            light: '#fff6e8',
            dark: '#80591e',
        },
        success: {
            main: '#4fb574',
            light: '#e3f3e7',
            dark: '#38754d',
        },
        text: {
            primary: '#2e2b2b',
            secondary: '#787575',
            disabled: '#b8b6b6',
        },
    },
    
    typography: {
        fontFamily: "'Titillium-Regular', sans-serif",
        fontSize: 16,
        h1: {
            fontSize: '40px',
            lineHeight: '52px',
            letterSpacing: '0',
        },
        h2: {
            fontSize: '28px',
            lineHeight: '40px',
            letterSpacing: 0,
        },
        h3: {
            fontSize: '22px',
            lineHeight: '32px',
            letterSpacing: 0,
        },
        h4: {
            fontSize: '18px',
            lineHeight: '28px',
            letterSpacing: 0,
            fontFamily: "'Titillium-Semibold', sans-serif",
        },
        h5: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
            fontFamily: "'Titillium-Semibold', sans-serif",
        },
        h6: {
            fontSize: '18px',
            lineHeight: '28px',
            letterSpacing: 0,
            fontFamily: "'Titillium-Semibold', sans-serif",
        },
        body1: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        body2: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0,
        },
        button: {
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '1.25px',
            fontFamily: "'Titillium-Semibold', sans-serif",
        },
        caption: {
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: 0,
        },
        overline: {
            fontSize: '12px',
            lineHeight: '20px',
            letterSpacing: '1.5px',
        },
    },
    overrides: {
        MuiStepConnector: {
            vertical: {
                marginLeft: "20px",
                padding: "0",
            }
        },
        MuiStepContent: {
            root: {
                marginLeft: "20px",
                marginTop: "0",
                paddingLeft: "34px",
            }
        },
        MuiStepLabel: {
            iconContainer: {
                paddingRight: "16px",
            },
            label: {
                fontSize: "16px",
                '&$active': {
                    color: "#1D5A6D",
                },
                '&$completed': {
                    color: "#1D5A6D",
                }
            },
            root: {
                margin: "4px 0",
                color: "#1D5A6D",
            }
        },
        MuiStepIcon: {
            root: {
                width: "38px",
                height: "38px",

                '&$active': {
                    color: stepperActiveColor,
                },
                '&$completed': {
                    color: stepperActiveColor,
                },

            },
            text: {
                fontSize: "10px",
                textAlign: "center",
                font: "normal normal normal 14px / 18px Univers",
                letterSpacing: "0px",
            },
        },
        MuiFormControl: {
            root: {
                width: '100%',
                maxWidth: '600px',
            },
        },
        MuiFormLabel: {
            root: {
                marginTop: '8px',
            },
        },
        MuiInputLabel: {
            outlined: {
                marginTop: '0',
            },
        },
        MuiStepper: {
            root: {
                padding: '24px 0',
            },
        },
        //MuiDialog: {
        //    paper: {
        //        padding: '0px',
        //    },
        //},
        //MuiDialogTitle: {
        //    root: {
        //        backgroundColor: '#383a53',
        //        padding: '18px 24px',
        //        color: '#ffffff',
        //        fontSize: '18px',
        //        lineHeight: '27px',
        //        fontFamily: "'Titillium-Semibold', sans-serif",
        //    },
        //},
        MuiPaper: {
            root: {
                color: "#404040",
                backgroundColor: 'transparent',
                //padding: '8px',
            },
        },
        //MuiSvgIcon: {
        //    root: {
        //        fontSize: '24px',
        //    },
        //    fontSizeSmall: {
        //        fontSize: '24px',
        //    },
        //},
        //MuiIcon: {
        //    fontSizeSmall: {
        //        fontSize: '24px',
        //    },
        //},
        //MuiButton: {
        //    root: {
        //        padding: '8px 16px',
        //    },
        //    outlined: {
        //        padding: '8px 16px',
        //    },
        //},
        //MuiIconButton: {
        //    root: {
        //        padding: '8px',
        //    },
        //},
        //MuiOutlinedInput: {
        //    root: {
        //        '&$focused $notchedOutline': {
        //            borderColor: '#535470',
        //        },
        //    },
        //},
        //MuiInputBase: {
        //    root: {
        //        color: '#787575',
        //    },
        //},
        //MuiFormGroup: {
        //    root: {
        //        display: 'block',
        //    },
        //},
        //MuiFormControlLabel: {
        //    label: {
        //        fontSize: '16px',
        //    },
        //},
        //MuiAppBar: {
        //    colorDefault: {
        //        backgroundColor: '#ffffff',
        //        color: '#787575',
        //    },
        //},
        //MuiTableCell: {
        //    head: {
        //        fontFamily: "'Titillium-Semibold', sans-serif",
        //    },
        //},
    },
});
export default theme;